// normalize CSS across browsers
import "./src/normalize.css"
// custom CSS styles
import "./src/style.css"

//import "prismjs/themes/prism.css"
import("prismjs/themes/prism-solarizedlight.css")
// Highlighting for code blocks
// Numbered lines in code blocks
import("prismjs/plugins/line-numbers/prism-line-numbers.css")
//shell prompt
import("prismjs/plugins/command-line/prism-command-line.css")

// Self-host Google Fonts by fontsource
// Only the latin subset: the full imports also bundle cyrillic and
// vietnamese subsets, which webpack inlines as base64 into every page.
import "@fontsource/montserrat/latin-400.css"
import "@fontsource/montserrat/latin-500.css"
import "@fontsource/montserrat/latin-600.css"
import "@fontsource/montserrat/latin-700.css"
import "@fontsource/montserrat/latin-800.css"
import "@fontsource/montserrat-alternates/latin-400.css"
import "@fontsource/montserrat-alternates/latin-700.css"
